import React from "react";
import { Stack } from "@mui/material";
import { HubButton } from "../../components";

const ShipmentOrdersPoNumber = ({ item }) => {
  const orders = item?.orders || [];

  return (
    <Stack direction="row" gap="5px">
      {orders?.map((o) => (
        <HubButton
          variant="text"
          size="small"
          page={`/orders/${o.id}`}
          label={o.poNumber}
          sx={{ ":hover": { span: { textDecoration: "underline" } } }}
        />
      ))}
    </Stack>
  );
};

export default ShipmentOrdersPoNumber;
